// extracted by mini-css-extract-plugin
module.exports = {"PartHolder":"SepratePart_PartHolder__WquKb","ImageHolder":"SepratePart_ImageHolder__1fzrw","TextPart":"SepratePart_TextPart__1fDAD"};